import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
    // return Promise.reject(error.response);
  }
);

function GetMainPageStat() {
  return client.get("Stats/GetMainPageStat");
}

function GetAccidentsStatusByRole(uid, roleNames) {
  return client.get(`Stats/GetAccidentsStatusByRole/${uid}?roleNames=${encodeURIComponent(roleNames)}`);
}

function GetAccidentLastDaysCount() {
  return client.get("Stats/GetAccidentLastDaysCount");
}

export { GetMainPageStat ,GetAccidentsStatusByRole,GetAccidentLastDaysCount};
